import { Input, Table, Select, Tabs } from "antd";
import styled, { createGlobalStyle } from "styled-components";
const { TabPane } = Tabs;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StatsCardsContainer = styled.div`
  display: flex;
  gap: 64px;
  margin-bottom: 24px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const StatsCard = styled.div`
  min-width: 200px;
  height: 100px;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(props) => {
    if (props.type === "APPROVED") return "#56BFE2";
    if (props.type === "PENDING") return "#4A627A";
    if (props.type === "REJECTED") return "#4A627A";
    if (props.type === "AWAITING") return "#4A627A";
    return "#f0f0f0";
  }};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    min-width: 160px;
    height: 80px;
    padding: 16px;
  }
`;

export const StatsCardTitle = styled.h3`
  color: white;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin: 0 0 6px 0;
  }
`;

export const StatsCardNumber = styled.div`
  color: white;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 1;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const StatusDiv = styled.div`
  max-width: 180px;
  min-width: 170px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  overflow: hidden;

  padding: 4px 8px;
  border-radius: 20px;

  font-family: "Open Sans";
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;

  background-color: ${(props) => {
    if (props.status === "APPROVED") return "#16A34A";
    if (props.status === "PENDING") return "#C0780C";
    if (props.status === "REJECTED") return "#B91C1C";
    if (props.status === "APPROVED_BY_SYSTEM") return "#16A34A";
    return "rgba(255, 223, 186, 1)";
  }};

  color: ${(props) => (props.status === "PENDING" ? "#FFF9EB" : "#FFFFFF")};

  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  transition: ${(props) => (props.disabled ? "none" : "all 0.25s ease")};

  span {
    transition: ${(props) =>
      props.disabled ? "none" : "opacity 0.2s ease, transform 0.2s ease"};
  }

  ${(props) =>
    !props.disabled &&
    `
    &::after {
      content: attr(data-hover);
      position: absolute;
      opacity: 0;
      transform: translateY(6px);
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    &:hover {
      transform: scale(1.05);
      background-color: ${
        props.status === "APPROVED"
          ? "#B91C1C" // vira vermelho
          : props.status === "REJECTED"
          ? "#16A34A" // vira verde
          : ""
      };
    }

    &:hover span {
      opacity: 0;
      transform: translateY(-6px);
    }

    &:hover::after {
      opacity: 1;
      transform: translateY(0);
    }
  `}
`;

export const SearchTableInput = styled(Input)`
  width: ${(props) => (props.dash ? "450px" : "100%")};
  box-sizing: border-box;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #dadada;
  background-color: #ffffff;
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #1e293b;
  margin-left: 25px;

  ${(props) =>
    !props.dash &&
    `
      @media (max-width: 1851px) {
        width: 100%;
      }
    `}

  .ant-input::placeholder {
    color: #1e293b;
    opacity: 0.6;
  }

  .ant-input {
    background-color: #ffffff;
    border: none;
    color: #1e293b;
    font-family: "Open Sans";
  }

  .ant-input-prefix {
    margin-right: 8px;
  }

  &:focus,
  &:hover {
    border-color: #dadada;
    box-shadow: none;
  }

  &:focus-within {
    border-color: #dadada;
    box-shadow: none;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const FilterSelect = styled(Select)`
  min-width: 280px;
  width: 280px;
  height: 35px;

  .ant-select-selector {
    border-radius: 8px !important;
    border: 1px solid rgba(217, 217, 217, 0.8) !important;
    background-color: rgba(255, 255, 255, 1) !important;
    height: 35px !important;
    align-items: center !important;
    font-family: "Open Sans" !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: rgba(68, 68, 68, 1) !important;
    transition: all 0.2s ease-in-out !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04) !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(68, 68, 68, 0.6) !important;
    opacity: 1 !important;
  }

  .ant-select-selection-item {
    color: rgba(68, 68, 68, 1) !important;
    background-color: rgba(17, 167, 217, 0.1) !important;
    border: 1px solid rgba(17, 167, 217, 0.3) !important;
    border-radius: 4px !important;
    margin: 2px !important;
    padding: 4px 8px !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;
    height: auto !important;
    line-height: 1.2 !important;
  }

  .ant-select-selection-item-content {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item-remove {
    color: rgba(17, 167, 217, 1) !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 14px !important;
    height: 14px !important;
    border-radius: 2px !important;
    transition: background-color 0.2s ease !important;

    &:hover {
      background-color: rgba(17, 167, 217, 0.2) !important;
    }

    .anticon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }

  &:focus,
  &:hover {
    .ant-select-selector {
      border-color: rgba(17, 167, 217, 0.6) !important;
      box-shadow: 0 2px 8px rgba(17, 167, 217, 0.15) !important;
    }
  }

  .ant-select-arrow {
    color: rgba(68, 68, 68, 0.8) !important;
    font-size: 16px !important;
    transition: transform 0.2s ease-in-out !important;
    margin-right: 8px !important;
    position: relative !important;
    z-index: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: none !important;
  }

  &.ant-select-open .ant-select-arrow {
    transform: rotate(180deg) !important;
  }

  /* Garantir que a arrow seja sempre visível */
  .ant-select-selection-search {
    margin-right: 30px !important;
  }

  .ant-select-selection-overflow {
    margin-right: 30px !important;
  }

  /* Forçar visibilidade do suffixIcon personalizado */
  .ant-select-suffix {
    color: rgba(68, 68, 68, 0.8) !important;
    font-size: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: none !important;
    margin-right: 8px !important;
    z-index: 2 !important;
  }

  &.ant-select-multiple .ant-select-suffix {
    display: flex !important;
  }

  /* Força a exibição do suffix icon mesmo em modo múltiplo */
  .ant-select-show-arrow .ant-select-suffix {
    opacity: 1 !important;
    visibility: visible !important;
  }

  &.ant-select-multiple.ant-select-show-arrow .ant-select-suffix {
    opacity: 1 !important;
    visibility: visible !important;
    display: flex !important;
  }
`;

export const SelectDropdownStyles = createGlobalStyle`
  .ant-select-dropdown {
    border-radius: 8px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid rgba(217, 217, 217, 0.3) !important;
    padding: 0 !important;
    background: white !important;
    max-height: 280px !important;
    min-width: 280px !important;
    overflow-y: auto !important;
    
    .ant-select-item {
      padding: 12px 20px !important;
      margin: 0 !important;
      border-radius: 0 !important;
      font-family: "Open Sans" !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: rgba(68, 68, 68, 1) !important;
      transition: all 0.15s ease-in-out !important;
      line-height: 1.3 !important;
      height: auto !important;
      min-height: 44px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      overflow: visible !important;
      border-bottom: 1px solid rgba(240, 240, 240, 0.8) !important;
      
      &:last-child {
        border-bottom: none !important;
      }
      
      &:hover {
        background-color: rgba(17, 167, 217, 0.08) !important;
        color: rgba(17, 167, 217, 1) !important;
      }
      
      &.ant-select-item-option-selected {
        background-color: rgba(17, 167, 217, 0.12) !important;
        color: rgba(17, 167, 217, 1) !important;
        font-weight: 500 !important;
        
        .ant-select-item-option-state {
          color: rgba(17, 167, 217, 1) !important;
        }
      }
      
      &.ant-select-item-option-active {
        background-color: rgba(17, 167, 217, 0.06) !important;
      }
    }
    
    .ant-select-item-option-content {
      flex: 1 !important;
      text-align: left !important;
      padding-right: 8px !important;
    }
    
    .ant-select-item-option-state {
      color: rgba(17, 167, 217, 1) !important;
      font-weight: 600 !important;
    }
    
    /* Estilização do scroll */
    .rc-virtual-list-scrollbar {
      width: 6px !important;
      
      .rc-virtual-list-scrollbar-thumb {
        background-color: rgba(17, 167, 217, 0.3) !important;
        border-radius: 3px !important;
        transition: background-color 0.2s ease !important;
        
        &:hover {
          background-color: rgba(17, 167, 217, 0.5) !important;
        }
      }
    }
    
    /* Para scroll nativo quando não há virtual list */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: rgba(17, 167, 217, 0.3);
      border-radius: 3px;
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: rgba(17, 167, 217, 0.5);
      }
    }
  }

  /* Estilo para quando o dropdown está aberto */
  .ant-select-dropdown.ant-select-dropdown-placement-bottomLeft,
  .ant-select-dropdown.ant-select-dropdown-placement-bottomRight {
    margin-top: 4px !important;
  }

  .ant-select-dropdown.ant-select-dropdown-placement-topLeft,
  .ant-select-dropdown.ant-select-dropdown-placement-topRight {
    margin-bottom: 4px !important;
  }

  /* Estilos para tooltips customizados */
  .ant-tooltip {
    .ant-tooltip-inner {
      background-color: rgba(0, 0, 0, 0.85) !important;
      color: white !important;
      font-family: "Open Sans" !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 1.4 !important;
      padding: 8px 12px !important;
      border-radius: 6px !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      max-width: 400px !important;
      word-wrap: break-word !important;
      text-align: left !important;
    }
    
    .ant-tooltip-arrow {
      .ant-tooltip-arrow-content {
        background-color: rgba(0, 0, 0, 0.85) !important;
      }
    }
  }
`;

export const RoundedTableContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  width: 100%;
  overflow-x: auto;
  margin-top: 16px;

  .rdt_Table {
    border-radius: 8px;
    width: 100%;
    min-width: 1100px;
    table-layout: fixed;
  }

  .rdt_TableHead {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .rdt_TableHeadRow .rdt_TableCol {
    color: #534d59;
  }

  .rdt_TableBody {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .rdt_TableCell {
    padding: 8px 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1e293b;
    font-family: "Inter";
  }

  /* Status e botão de ação mantêm Open Sans */
  .rdt_TableCell:nth-last-child(-n + 2) {
    font-family: "Open Sans";
  }

  .rdt_TableRow {
    min-height: 60px;
  }

  @media (max-width: 1600px) {
    .rdt_Table {
      min-width: 1200px;
    }
  }

  @media (max-width: 1400px) {
    .rdt_Table {
      min-width: 1000px;
    }

    .rdt_TableCell {
      padding: 6px 12px;
      font-size: 13px;
    }
  }

  @media (max-width: 1200px) {
    .rdt_Table {
      min-width: 900px;
    }

    .rdt_TableCell {
      padding: 6px 10px;
      font-size: 13px;
    }
  }

  @media (max-width: 768px) {
    .rdt_Table {
      min-width: 700px;
    }

    .rdt_TableCell {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
`;

export const AreaBreadcrumbWithEvent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 36px;
`;

export const TitleContainer = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChangeEventButton = styled.button`
  background: none;
  border: none;
  color: #002244;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin: 0;
  transition: color 0.2s ease;

  &:hover {
    color: #003366;
  }

  &:active {
    color: #001122;
  }
`;

export const BreadcrumbText = styled.div`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 18px;
  line-height: 100%;
  color: #002244;
`;

export const TabsAndFilterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0 !important;
`;

export const TableTab = styled.div`
  height: 40px;
  align-items: center;
  text-align: center;
  justify-content: center;
  display: flex;
  padding-inline: 24px;
  max-width: 262px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  border: 1px solid var(--dark-4, rgba(199, 201, 217, 1));
  white-space: nowrap;
  cursor: pointer;
  background-color: ${(props) =>
    props.active ? "transparent" : "rgba(221, 229, 233, 1)"};
  color: ${(props) =>
    props.active ? "rgba(58, 58, 60, 1)" : "rgba(108, 108, 108, 1)"};
  transition: all 0.25s ease-in-out, transform 0.15s ease-in-out;

  &:active {
    transform: scale(0.97);
  }

  /* 🔽 Responsividade */
  @media (max-width: 1560px) {
    font-size: 14px;
    padding-inline: 16px;
    max-width: 220px;
    height: 36px;
  }

  @media (max-width: 1280px) {
    font-size: 13px;
    padding-inline: 12px;
    max-width: 180px;
    height: 34px;
  }

  @media (max-width: 1024px) {
    font-size: 12px;
    padding-inline: 10px;
    max-width: 160px;
  }
`;

export const SelectsFilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-left: 24px;
`;

export const TopActionButton = styled.button`
  margin-left: 15px;
  min-width: 185px !important;
  height: 38px;
  border-radius: 5px;
  opacity: 1;
  justify-content: center;
  gap: 8px;
  font-family: Open Sans;
  background: #002244;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  border: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  align-items: center;
  display: flex;
  gap: 8px;

  &:hover {
    background: rgba(1, 30, 59, 1);
    color: #fff;
  }

  &:active {
    background: #002244;
    color: #fff;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const BtnInfo = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: end;
  align-items: center;
  border-radius: 10px;
  color: #002244;
`;
